const OutrightAddMapper = (data, context) => {
    return data;
};

export default OutrightAddMapper;
